import theme from "../theme"

export default (props)=> (
    <span {...props} style={{...styles, ...props?.style}}  />
)

const styles = {
    color: theme.primaryText,
    fontSize: 14
}